module.exports = __webpack_public_path__ + "static/media/black-tie.eb0acbbd.svg";